import React from 'react';

const defaultValue = {
  isLive: false,
  taxonomyPath: null,
};

export const LiveBlogContext = React.createContext(defaultValue);
